import styled, { css } from 'styled-components';
import { theme } from '../../theme';
import { ProgressSize } from './Progress';

const ProgressContainerStylesSmall = css`
  flex-direction: row;
  justify-content: space-between;
  padding: ${theme.spacings[3].rem} ${theme.spacings[4].rem};
  border-bottom: 1px solid ${theme.colors.neutrals.solidGrays[5]};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
`;

const ProgressContainerStylesLarge = css`
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  border-bottom: 1px solid transparent;
  box-shadow: none;
`;

const containerSizeStyles = {
  small: ProgressContainerStylesSmall,
  large: ProgressContainerStylesLarge,
};

type ProgressContainerProps = { size: ProgressSize };

export const ProgressContainer = styled.nav<ProgressContainerProps>`
  display: flex;
  margin: 0;
  background-color: ${theme.colors.primary.white};

  ${({ size }) => containerSizeStyles[size]};
`;
